import { render, staticRenderFns } from "./OnboardingImportSimpleMethodModal.vue?vue&type=template&id=c90db48a&scoped=true"
import script from "./OnboardingImportSimpleMethodModal.vue?vue&type=script&lang=js"
export * from "./OnboardingImportSimpleMethodModal.vue?vue&type=script&lang=js"
import style0 from "./OnboardingImportSimpleMethodModal.vue?vue&type=style&index=0&id=c90db48a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c90db48a",
  null
  
)

export default component.exports